export default __webpack_public_path__ + "static/media/us-gu.5ec1480e.svg";